// extracted by mini-css-extract-plugin
export default {"TemplateGroup":"_TemplateGroup--eJoZd","Description":"_Description--rgisW"};